export default __webpack_public_path__ + "static/media/toll-field.0560f9f3.svg";